module.exports = __webpack_public_path__ + "img/removevendor.2191ce42.svg";